export enum InvoiceQuerySort {
    ById,
    ByDueDate,
    ByPayment
}
